<div class="smart-input-container">
  <div class="input-wrapper">
    <input
      #inputEl
      [type]="inputType"
      [placeholder]="placeholder"
      [value]="displayValue"
      (input)="onInputChange($event)"
      (blur)="onInputBlur()"
      (focus)="onInputFocus()"
      (click)="onInputClick($event)"
      (dragover)="$event.preventDefault()"
      (drop)="onDrop($event)"
      class="smart-input"
      [ngClass]="getInputClass()"
      />

    <!-- Match Badge -->
    @if (showBadge) {
      <button
        type="button"
        class="match-badge"
        [ngClass]="getBadgeClass()"
        (click)="handleBadgeClick($event)"
        >
        <i class="material-symbols-rounded">{{ getBadgeIcon() }}</i>
        <span>{{ getBadgeText() }}</span>
      </button>
    }

    <!-- Suggestion Wand (Only if not matching type or small value) -->
    @if (suggestion && !linkedId && (!matchingType || (value || '').toString().length <= 2)) {
      <button
        (click)="applySuggestion()"
        class="suggestion-btn"
        [title]="'AI Suggestion: ' + suggestion.value"
        >
        <i class="material-symbols-rounded">auto_fix_high</i>
      </button>
    }
  </div>

  <!-- Error Message -->
  @if (error && touched) {
    <div class="error-message">
      {{ error }}
    </div>
  }

  <!-- Matching Dropdown -->
  @if (showDropdown && (matches.length > 0 || linkedId)) {
    <div class="match-dropdown">
      <div class="dropdown-header">
        <span>System Matches</span>
      </div>
      <!-- Create New Option (if linked) -->
      @if (linkedId) {
        <button
          (mousedown)="createNew()"
          class="match-option"
          >
          <div class="match-icon-wrapper create-new">
            <i class="material-symbols-rounded">check</i>
          </div>
          <div class="create-new-text">
            <span class="title">Create New Record</span>
            <p class="subtitle">Unlink from current system record</p>
          </div>
        </button>
      }
      @for (match of matches; track match) {
        <button
          (mousedown)="selectMatch(match)"
          class="match-option"
          [class.selected]="linkedId === match.id"
          >
          <div class="match-icon-wrapper" [ngClass]="getMatchIconClass(match)">
            <i class="material-symbols-rounded">{{ getMatchIcon(match) }}</i>
          </div>
          <div class="match-content">
            <div class="match-header">
              <span class="match-label">{{ match.label }}</span>
              <span class="match-score" [ngClass]="match.score > 0.9 ? 'high' : 'low'">{{ (match.score * 100).toFixed(0) }}%</span>
            </div>
            @if (match.subLabel) {
              <div class="match-sublabel">{{ match.subLabel }}</div>
            }
          </div>
        </button>
      }
    </div>
  }
</div>
